import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved || 'light';
  });

  const [bgAnimation, setBgAnimation] = useState(() => {
    const saved = localStorage.getItem('bgAnimation');
    return saved !== null ? saved === 'true' : true; // по умолчанию включено
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('bgAnimation', bgAnimation);
  }, [bgAnimation]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const toggleBgAnimation = () => {
    setBgAnimation(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, bgAnimation, toggleBgAnimation }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);